<template>

	<div>

		<div class="project-tiles">
			<div 
				:class="{'project-tile':true,panelShadowDeep:true,hide:!!project.hide,giveBG:!show('weekly-insights', 'setup', project)}"
				v-for="(project, projectIndex) in projectTiles" 
				:key="'project-tile-'+projectIndex"
			>

				<div class="project-tile-header" v-if="!project.hide">
					<span class="name" v-html="project.name" />
					<span class="url" v-html="project.url.label" />
				</div>

				<div class="project-tile-content" v-if="!project.hide">

					<div :class="{'project-tile-content-item': true, active: project.dataDive.has}" @click="clicked('data-dive', project)">

						<div class="hover panelShadowDeep" v-if="!show('data-dive', 'setup', project)" />

						<div class="project-tile-content-item-title-section">

							<h2 class="project-tile-content-item-title">

								<Icon type="data-dive" class="svg" />

								<span class="project-tile-content-item-title-text">Data Dive</span>

							</h2>

						</div> 

						<div :class="{'project-tile-content-item-stats-section': true}">

							<TableStats :settings="project.dataDive" :forTile="true" @setUp="setUp" />

						</div>

					</div>

					<div :class="{'project-tile-content-item': true, active: project.rankTracking.has}" @click="clicked('rank-tracking', project)">

						<div class="hover panelShadowDeep" v-if="!show('rank-tracking', 'setup', project)" />

						<div class="project-tile-content-item-title-section">

							<h2 class="project-tile-content-item-title">

								<Icon type="rank-tracking" class="svg" />

								<span class="project-tile-content-item-title-text">Rank Tracking</span>

							</h2>

							<ProjectFeatures 
								v-if="!show('rank-tracking', 'setup', project)"
								:project="project"
								:show="['device','searchType','paused']"
							/>

						</div>

						<div class="project-tile-content-item-stats-section">

							<TableStats :settings="project.rankTracking" :forTile="true" @setUp="setUp" />

						</div>

					</div>

					<div :class="{'project-tile-content-item': true, active: project.contentKeywords && project.contentKeywords.has}" @click="clicked('content-keywords', project)">

						<div class="hover panelShadowDeep" v-if="!show('content-keywords', 'setup', project)" />

						<div class="project-tile-content-item-title-section">

							<h2 class="project-tile-content-item-title">

								<Icon type="content-keywords" class="svg" />

								<span class="project-tile-content-item-title-text">Content &amp; Keywords</span>

							</h2>

						</div>

						<div class="project-tile-content-item-stats-section">

							<TableStats :settings="project.contentKeywords" :forTile="true" @setUp="setUp" />

						</div>

					</div>

					<div :class="{'project-tile-content-item': true, active: true}" v-if="!show('weekly-insights', 'setup', project)" @click="clicked('weekly-insights', project)">

						<div class="project-tile-content-item-title-section">

							<h2 class="project-tile-content-item-title">

								<Icon type="weekly-insights" class="svg" />

								<span class="project-tile-content-item-title-text">Weekly Insights</span>

							</h2>

						</div>

						<div class="project-tile-content-item-stats-section">

							<TableStats :settings="project.weeklyInsights" :forTile="true" />

						</div>

					</div>

					<div :class="{'project-tile-content-item': true, actions: true}" v-if="showActions">

						<Icon type="copy" class="svg" colour="#000" @clicked="actioned('duplicate', project)" />

						<Icon type="delete" class="svg" colour="#000" @clicked="actioned('deletePause', project)" />

					</div>

				</div>
				
			</div>

		</div>

		<Pagination
			:thePages="tableInfo.pages"
			:thePage="tableInfo.page"
			:page="tableInfo.page"
			@changePage="changePage"
		/>
	
	</div>

</template>

<script>
import ProjectFeatures from './ProjectFeatures.vue'
import Icon from './Icon.vue'
import TableStats from './TableStats.vue'
import Pagination from './Pagination.vue'
export default {
	name: 'ProjectTiles',
	props: {
		tableInfo: {
			type: Object,
			default: () => {}
		},
	},
	components: { ProjectFeatures, Icon, TableStats, Pagination },
	data() {

		return {
			showActions: false
		}

	},
	computed: {

		projectTiles() {

			let p = this.projects, 
				n = Math.ceil(p.length / 3) * 3;
				
			while ( p.length < n ) {

				p.push({ hide: true });

			}

			return p;

		},
		projects () {

			return !!this.tableInfo.items ? this.tableInfo.items : [];

		}

	},
	methods: {

		changePage( pageNumber ) {

			switch ( pageNumber ) {

				case 'start' :
					pageNumber = 1;
				break;
				case 'previous' :
					pageNumber = this.thePage - 1;
				break;
				case 'next' :
					pageNumber = this.thePage + 1;
				break;
				case 'end' :
					pageNumber = this.thePages;
				break;

			}

			if ( this.internalPagination ) {

				this.thePage = pageNumber;

			}
			else {
				
				this.$emit( 'pagination', { page: pageNumber } );

			}

		},

		clicked( section, project) {

			if ( !this.show( section, 'setup', project ) ) {

				this.$router.push( project.urls[ section ] );

			}

		},

		actioned(type,project) {

			this.$emit(type, project);

		},

		show ( section, type, project ) {

			switch (section) {

				case 'data-dive' :

					switch (type) {

						case 'setup' :

						return !project.hasDataDive;

						case 'fetching' :

						return project.hasDataDive&&(!project.lastGraphStats||!project.lastGraphStats.current);

						case 'stats' :

						return project.hasDataDive&&project.lastGraphStats&&project.lastGraphStats.current;

					}

				break;

				case 'rank-tracking' :

					switch (type) {

						case 'setup' :

						return !project.hasRankTracking;

						case 'fetching' :

						return project.hasRankTracking&&project.rankCaddyScore.value.value===0&&project.keywordCount.keywordCount===0;

						case 'stats' :

						return project.hasRankTracking&&project.keywordCount.keywordCount>0;

						case 'stats2' :

						return project.hasRankTracking&&project.rankCaddyScore.value.value>0;

					}

				break;

				case 'content-keywords' :

					switch (type) {

						case 'setup' :

						return !project.hasContentKeywords;

						case 'stats' :

						return project.hasContentKeywords;

					}

				break;

				case 'weekly-insights' :

					switch (type) {

						case 'setup' :

						return !!project.weeklyInsights && !project.weeklyInsights.has;

						case 'stats' :

						return !!project.weeklyInsights && !!project.weeklyInsights.has;

					}

				break;

			}

		},

		setUp(info) {

			this.$emit('setUp', info);

		},
		formatNumber (n) {

			let am = 'K', tot = parseFloat( ( n + '' ).replace(',','') );

			if ( tot >= 1000000 ) {

				am = 'M';
				tot /= 1000;

			}
			else if ( tot > 1000 ) {

				tot /= 1000;

				if ( parseFloat( tot.toFixed(0) ) < parseFloat( tot.toFixed(1) ) ) {

					tot = tot.toFixed(1);

				}
				else {

					tot = tot.toFixed(0);

				}

				return tot + am;

			}
			else {

				if ( ( n + '' ).length > 5 ) {

					tot = tot.toFixed(2);

				}

			}

			return tot;

		}

	}
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.project-tiles {

	.project-tile {

		margin-bottom: 30px;
		background-color: #fff;
		.rounded(12px);

		&.giveBG {

			background-color: rgba(248, 250, 251, 1);

		}

		&.hide {

			opacity: 0;

		}

		.project-tile-header {

			background-color: @darkContrast;
			border-radius: 12px 12px 0 0;
    		padding: 15px 25px 8px;

			span {

				color: #fff;
				display: block;

				&.name {

					font-weight: @bold;

				}

			}

		}

		.project-tile-content {

			border-radius: 0 0 12px 12px;

			.project-tile-content-item {

				padding: 15px 25px;
				position: relative;
				background-color: #fff;

				&.actions {

					.svg {

						width: 20px;
						margin-right: 20px;
						opacity: 0.5;
						cursor: pointer;
						.trans;
						&:hover {

							opacity: 1;

						}

					}

				}

				.large-button {

					margin: 0;

					&.mini {

						min-width: 180px;

					}

				}

				.hover {

					position: absolute;
					top: -0.5vw;
					left: -0.5vw;
					right: -0.5vw;
					bottom: -0.5vw;
					z-index: 1;
					display: none;
					background-color: white;

				}

				&.active {

					cursor: pointer;

					&:hover {

						.hover {

							display: block;

						}

					}

				}

				&:nth-child(even) {

					background-color: rgba(248, 250, 251, 1);

					.hover {

						background-color: rgba(248, 250, 251, 1);

					}

				}

				&:last-child {

					border-radius: 0 0 12px 12px;
					padding-bottom: 25px;

				}

				&.white {

					background-color: #fff !important;

				}

				&:not(.active) {

					.project-tile-content-item-title-section {

						opacity: 0.5;

					}

				}

				.project-tile-content-item-title-section {

					margin-bottom: 10px;
					display: flex;
					align-items: center;
					justify-content: flex-start;
					position: relative;
					z-index: 2;

					.project-tile-content-item-title {

						display: flex;
						align-items: center;
						justify-content: flex-start;
						margin: 0 30px 0 0;
						padding: 0;

						.svg, svg {

							width: 24px;

						}

						span {

							margin-left: 10px;
							font-size: 18px;

						}

					}

				}

				.project-tile-content-item-stats-section {

					margin: 0;
					padding: 0;
					position: relative;
					z-index: 2;

				}

			}

		}

	}

}
@media screen and (min-width: 680px) {

	.project-tiles {

		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		.project-tile {

			width: 48%;
			flex-grow: 0;
			flex-shrink: 0;


		}

	}

}
@media screen and (min-width: 940px) {

	.project-tiles {

		.project-tile {

			width: 49%;

		}

	}

}
@media screen and (min-width: 1024px) {

	.project-tiles {

		.project-tile {

			.project-tile-header {

				span {

					font-size: 16px;

				}

			}

			.project-tile-content {

				.project-tile-content-item {

					.large-button {

						&.mini {

							min-width: 156px;
							font-size: 14px;

						}

					}

					.project-tile-content-item-title-section {

						margin-bottom: 5px;

						.project-tile-content-item-title {

							.svg, svg {

								width: 20px;
    							height: 20px;

							}

							span {

								margin-left: 10px;
								font-size: 16px;

							}

						}

					}

					.project-tile-content-item-stats-section {

						.large-button {

							margin-top: 5px;

						}

						

					}

				}

			}

		}

	}

}
@media screen and (min-width: 1280px) {

	.project-tiles {

		.project-tile {

			width: 32%;

		}

	}

}
</style>